/**
 * 按段比较语义化版本。
 * @returns 正数：a > b；0：相等；负数：a < b
 */
export function compareVersion(a: string, b: string): number {
  const left = (a || '0').split('.').map((part) => Number.parseInt(part, 10) || 0);
  const right = (b || '0').split('.').map((part) => Number.parseInt(part, 10) || 0);
  const length = Math.max(left.length, right.length);

  for (let i = 0; i < length; i++) {
    const x = left[i] ?? 0;
    const y = right[i] ?? 0;
    if (x !== y) {
      return x > y ? 1 : -1;
    }
  }
  return 0;
}

/** 当前版本是否低于最低要求版本 */
export function isVersionOutdated(current: string, minVersion: string): boolean {
  return compareVersion(current, minVersion) < 0;
}
